import CategoryList from "../container/category/CategoryList";
import Category from "../container/category/Form";
import Dashboard from "../container/dashboard/Dashboard";
import File from "../container/file/Form";
import FileList from "../container/file/FileList";
import Product from "../container/product/Form";
import ProductList from "../container/product/ProductList";
import ProductPriceImport from "../container/product/ProductPriceImport";
import ProductDiscountImport from "../container/product/ProductDiscountImport";
import User from "../container/user/Form";
import UserList from "../container/user/UserList";
import ProductShipping from "../container/product-shipping/Form";
import ProductShippingList from "../container/product-shipping/ProductShippingList";
import Discount from "../container/discount/Form";
import Campaigns from "../container/campaign/Campaigns";
import OrderList from "../container/orders/OrderList";
import ShowSingleOrder from "../container/orders/ShowSingleOrder";
import Coupon from "../container/coupon/Form";
import CouponList from "../container/coupon/CouponList";
import LearnCategory from "../container/leran-category/Form";
import LearnCategoryList from "../container/leran-category/LearnCategoryList";
import Learn from "../container/learn/Form";
import LearnList from "../container/learn/LearnList";
import Export from "../container/export/Export";
import Article from "../container/article/Form";
import ArticleList from "../container/article/ArticleList";
import Deposit from "../container/wallets/Form";
import BulkDepositHistory from "../container/wallets/BulkDepositHistory";
import BulkDeposit from "../container/wallets/BulkDeposit";
import WalletsTransaction from "../container/wallets/WalletsTransaction";
import ProductsReports from "../container/reports/products-reports/ProductsReports";
import ProductSalesSummary from "../container/reports/ProductSalesSummary";
import OrderStatistics from "../container/reports/OrderStatistics";
import MonthlyOrderCohort from "../container/reports/MonthlyOrderCohort";
import UsersReports from "../container/reports/users-reports/UsersReports";
import OrdersReports from "../container/reports/orders-reports/OrdersReports";
import Slider from "../container/slider/Form";
import ProvinceList from "../container/province-and-city/ProvinceList";
import EditCities from "../container/province-and-city/Form";
import BarcodesUpload from "../container/orders/BarcodesUpload";
import VendorStoreCategory from "../container/vendor-store-categories/Form";
import VendorStoreCategoryList from "../container/vendor-store-categories/VendorStoreCategoryList";
import VendorStoresList from "../container/vendor-stores/VendorStoresList";
import VendorStores from "../container/vendor-stores/Form";
import SliderList from "../container/slider/SliderList";
import VendorProductList from "../container/vendor-store-product/VendorProductList";
import ShowVendorProduct from "../container/vendor-store-product/ShowVendorProduct";
import Course from "../container/course/Form";
import CourseList from "../container/course/CourseList";
import FAQ from "../container/faq/Form";
import FaqList from "../container/faq/FaqList";
import PublicField from "../container/public-fields/Form";
import UsersCourseEnrollmentsReport from "../container/reports/users-CourseEnrollments-report/UsersCourseEnrollmentsReports";
import AllOrderReports from "../container/reports/all-orders-reports/AllOrdersReports";
import VendorFileList from "../container/file/VendorFileList";
import CourseEnrollmentsList from "../container/courseEnrollments/CourseEnrollmentsList";
import RegisterMultiple from "../container/courseEnrollments/RegisterMultiple";
import UpdateProductStockList from "../container/product/UpdateProductStockList";
import UpdateProductsStockLogs from "../container/product/UpdateProductsStockLogs";
import BackupList from "../container/backup/BackupList";
import CourseEnrollmentsReports from "../container/reports/courseEnrollments-report/CourseEnrollmentsReports";
import CustomerSalesReports from "../container/reports/customers-sales/CustomerSalesReports";
import ProvinceSalesReports from "../container/reports/province-sales/ProvinceReports";
import ProductStockList from "../container/product-stock/ProductStockList";
import AffiliateEnrollmentsList from "../container/affiliateEnrollments/affiliateEnrollmentsList";
import UpdateSettings from "../container/settings/UpdateSettings";
import SidebarSettings from "../container/settings/SidebarSettings";

import OrderAppearanceSettings from "../container/settings/OrderAppearanceSettings";
import AccessSettings from "../container/settings/AccessSettings";
import MaintenanceSettings from "../container/settings/MaintenanceSettings";

export const routes = [
  { path: "/settings/maintenance", component: <MaintenanceSettings /> },
  { path: "/product-discounts", component: <ProductDiscountImport /> },
  { path: "/settings/access", component: <AccessSettings /> },
  { path: "/settings/order-appearance", component: <OrderAppearanceSettings /> },
  {
    path: "/settings/updates",
    component: <UpdateSettings />,
  },
  {
    path: "/settings/sidebar",
    component: <SidebarSettings />,
  },
  {
    path: "/",
    component: <Dashboard />,
  },
  {
    path: "/add-user",
    component: <User />,
  },
  {
    path: "/edit-user",
    component: <User />,
  },
  {
    path: "/user-list",
    component: <UserList />,
  },
  {
    path: "/add-category",
    component: <Category />,
  },
  {
    path: "/edit-category",
    component: <Category />,
  },
  {
    path: "/category-list",
    component: <CategoryList />,
  },
  {
    path: "/add-vendor-store-category",
    component: <VendorStoreCategory />,
  },
  {
    path: "/edit-vendor-store-category",
    component: <VendorStoreCategory />,
  },
  {
    path: "/vendor-store-category-list",
    component: <VendorStoreCategoryList />,
  },
  {
    path: "/add-learn-category",
    component: <LearnCategory />,
  },
  {
    path: "/edit-learn-category",
    component: <LearnCategory />,
  },
  {
    path: "/learn-category-list",
    component: <LearnCategoryList />,
  },
  {
    path: "/add-product",
    component: <Product />,
  },
  {
    path: "/edit-product",
    component: <Product />,
  },
  {
    path: "/product/:id",
    component: <Product />,
  },
  {
    path: "/product-list",
    component: <ProductList />,
  },
  {
    path: "/product-price-import",
    component: <ProductPriceImport />,
  },
  {
    path: "/update-product-stock-list",
    component: <UpdateProductStockList />,
  },
  {
    path: "/file",
    component: <File />,
  },
  {
    path: "/file-list",
    component: <FileList />,
  },
  {
    path: "/file-list/vendors",
    component: <VendorFileList />,
  },
  {
    path: "/add-product-shipping",
    component: <ProductShipping />,
  },
  {
    path: "/edit-product-shipping",
    component: <ProductShipping />,
  },
  {
    path: "/product-shipping-list",
    component: <ProductShippingList />,
  },
  {
    path: "/product-stocks-list",
    component: <ProductStockList />,
  },
  {
    path: "/reports/product-stocks",
    component: <ProductStockList />,
  },
  {
    path: "/discount-manage",
    component: <Discount />,
  },
  {
    path: "/campaigns",
    component: <Campaigns />,
  },
  {
    path: "/public-field-manage",
    component: <PublicField />,
  },
  {
    path: "/order-list",
    component: <OrderList />,
  },
  {
    path: "/order-list/:id",
    component: <ShowSingleOrder />,
  },
  {
    path: "/add-coupon",
    component: <Coupon />,
  },
  {
    path: "/edit-coupon",
    component: <Coupon />,
  },
  {
    path: "/coupon-list",
    component: <CouponList />,
  },
  {
    path: "/add-learn",
    component: <Learn />,
  },
  {
    path: "/edit-learn",
    component: <Learn />,
  },
  {
    path: "/learn-list",
    component: <LearnList />,
  },
  {
    path: "/export",
    component: <Export />,
  },
  {
    path: "/add-article",
    component: <Article />,
  },
  {
    path: "/edit-article",
    component: <Article />,
  },
  {
    path: "/article-list",
    component: <ArticleList />,
  },
  {
    path: "/add-deposit",
    component: <Deposit />,
  },
  {
    path: "/wallets/bulk-history",
    component: <BulkDepositHistory />,
  },
  {
    path: "/wallets/bulk-deposit",
    component: <BulkDeposit />,
  },
  {
    path: "/wallets-transaction",
    component: <WalletsTransaction />,
  },
  {
    path: "/reports/products",
    component: <ProductsReports />,
  },
  {
    path: "/reports/product-sales-summary",
    component: <ProductSalesSummary />,
  },
  {
    path: "/reports/order-statistics",
    component: <OrderStatistics />,
  },
  {
    path: "/reports/monthly-order-cohort",
    component: <MonthlyOrderCohort />,
  },
  {
    path: "/update-product-stock-report",
    component: <UpdateProductsStockLogs />,
  },
  {
    path: "/reports/orders",
    component: <OrdersReports />,
  },
  {
    path: "/reports/users",
    component: <UsersReports />,
  },
  {
    path: "/reports/customers-sales",
    component: <CustomerSalesReports />,
  },
  {
    path: "/reports/provinces-sales",
    component: <ProvinceSalesReports />,
  },
  {
    path: "/reports/all-orders",
    component: <AllOrderReports />,
  },
  {
    path: "/reports/userCourseEnrollments",
    component: <UsersCourseEnrollmentsReport />,
  },
  {
    path: "/reports/courseEnrollments",
    component: <CourseEnrollmentsReports />,
  },
  {
    path: "/affiliateEnrollments-list",
    component: <AffiliateEnrollmentsList />,
  },
  {
    path: "/add-slider",
    component: <Slider />,
  },
  {
    path: "/edit-slider",
    component: <Slider />,
  },
  {
    path: "/slider-list",
    component: <SliderList />,
  },
  {
    path: "/province-list",
    component: <ProvinceList />,
  },
  {
    path: "/edit-cities",
    component: <EditCities />,
  },
  {
    path: "/barcodes-upload",
    component: <BarcodesUpload />,
  },
  {
    path: "/vendor-stores-list",
    component: <VendorStoresList />,
  },
  {
    path: "/add-vendor-store",
    component: <VendorStores />,
  },
  {
    path: "/edit-vendor-store",
    component: <VendorStores />,
  },
  {
    path: "/vendor-product-list",
    component: <VendorProductList />,
  },
  {
    path: "/show-vendor-product",
    component: <ShowVendorProduct />,
  },
  {
    path: "/add-course",
    component: <Course />,
  },
  {
    path: "/edit-course",
    component: <Course />,
  },
  {
    path: "/course-list",
    component: <CourseList />,
  },
  {
    path: "/add-faq",
    component: <FAQ />,
  },
  {
    path: "/edit-faq",
    component: <FAQ />,
  },
  {
    path: "/faq-list",
    component: <FaqList />,
  },
  {
    path: "/courseenrollment-list",
    component: <CourseEnrollmentsList />,
  },
  {
    path: "/courseenrollment-register-multiple",
    component: <RegisterMultiple />,
  },
  {
    path: "/backup-list",
    component: <BackupList />,
  },
];
